<app-team-info></app-team-info>
<div class="team-user-scrollable-container">
  <div class="team-users-container">
    <app-team-user *ngFor="let user of leftUsers;" [user]="user"></app-team-user>
  </div>
  <div class="team-users-container">
    <app-team-user *ngFor="let user of rightUsers;" [user]="user"></app-team-user>
  </div>
</div>
